import { useEffect, useState } from "react";

/**
 * useFDPClock
 *
 * Accepts the FDP end limit as a pre-computed UTC Date (from the engine's
 * result.limits.dutyEndLimit) rather than recomputing it from dutyStart +
 * fdpLimit — the engine is the single source of truth for that value.
 *
 * @param {Date|null} dutyEndLimit - UTC Date when the FDP expires
 * @returns {{ remainingMin: number, expired: boolean } | null}
 */
export function useFDPClock(dutyEndLimit) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  if (!dutyEndLimit || !(dutyEndLimit instanceof Date) || isNaN(dutyEndLimit.getTime())) {
    return null;
  }

  const remainingMin = Math.floor((dutyEndLimit - now) / 60000);
  return {
    remainingMin,
    expired: now > dutyEndLimit,
  };
}